import TextArea from '@betterfunnel/ui-core/TextArea';
import { useEffect, useState } from 'react';

interface Props {
  title?: string;
  editable?: boolean;
  value?: string;
  setValue?: any;
  update?: any;
  rows?: number;
}

export default function SettingSectionTextArea({
  title,
  editable,
  value,
  setValue,
  update,
  rows = 5,
}: Props) {
  const [editing, setEditing] = useState(false);
  const [initialValue, setInitialValue] = useState('');

  useEffect(() => {
    if (editing) {
      setInitialValue(value as string);
    }
  }, [editing]);

  return (
    <div className="flex flex-col gap-0 pt-6">
      <dt className="font-medium text-gray-900 sm:w-64 sm:flex-none sm:pr-6">
        {title}
      </dt>
      <dd className="mt-1 flex flex-col justify-between gap-2 gap-x-6 sm:mt-0 sm:flex-auto">
        <TextArea
          key={'edit-name'}
          value={value}
          onChange={(v) => setValue(v.target.value)}
          disabled={!editing}
          rows={rows}
        />
        <div className="flex gap-4">
          {editing ? (
            <button
              type="button"
              className="font-semibold text-gray-600 hover:text-gray-500"
              onClick={() => {
                {
                  setValue(initialValue as string);
                  setEditing((a) => !a);
                }
              }}
            >
              Cancel
            </button>
          ) : (
            <></>
          )}
          {editable ? (
            <button
              type="button"
              className="font-semibold text-indigo-600 hover:text-indigo-500"
              onClick={() => {
                setEditing((a) => !a);
                if (editing) {
                  update();
                }
              }}
            >
              {editing ? 'Save' : 'Edit'}
            </button>
          ) : (
            <></>
          )}
        </div>
      </dd>
    </div>
  );
}
